import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="screen-min-h-full glass-bg p-6 flex items-center justify-center">
          <div className="glass-panel rounded-xl p-6 max-w-md mx-auto text-center">
            <h2 className="glass-text mb-4">Что-то пошло не так</h2>
            <p className="glass-text-secondary mb-4">
              Приложение столкнулось с ошибкой. Попробуйте обновить страницу.
            </p>
            <button 
              onClick={() => window.location.reload()}
              className="glass-interactive px-4 py-2 rounded-lg glass-text"
            >
              Обновить страницу
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;